(function () {
  'use strict';

  var page = document.documentElement;
  var rootSelector = '#judgeme_product_reviews';
  var observer;
  var observedRoot;
  var checkQueued = false;
  var revealQueued = false;

  function judgeStylesAreLoaded() {
    for (var i = 0; i < document.styleSheets.length; i++) {
      var href = document.styleSheets[i].href || '';
      if (/judge\.me|judgeme|widget_v3/i.test(href)) return true;
    }
    return false;
  }

  function findReadyWidget(root) {
    var currentWidget = root.querySelector(
      '.jm-review-widget[data-widget-container="review-widget"], [data-widget-container="review-widget"].jm-review-widget'
    );

    if (currentWidget && currentWidget.querySelector('.jm-review-widget__header-and-body') && judgeStylesAreLoaded()) {
      return currentWidget;
    }

    // Retain compatibility if Judge.me switches this shop back to its legacy
    // widget. Its temporary hiding style is removed once that widget is ready.
    var legacyWidget = root.querySelector('.jdgm-rev-widg');
    var isReadyEmptyWidget =
      legacyWidget &&
      legacyWidget.getAttribute('data-number-of-reviews') === '0' &&
      root.classList.contains('jdgm--done-setup-widget') &&
      judgeStylesAreLoaded();

    if (
      legacyWidget &&
      window.getComputedStyle(legacyWidget).display !== 'none' &&
      (!legacyWidget.querySelector('.jdgm-temp-hiding-style') || isReadyEmptyWidget)
    ) {
      return legacyWidget;
    }

    return null;
  }

  function reveal(root) {
    if (revealQueued || root.classList.contains('hadiyah-judgeme-ready')) return;
    revealQueued = true;

    // Let Judge.me finish the current render before exposing its subtree.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        root.classList.add('hadiyah-judgeme-ready');
        root.removeAttribute('aria-busy');
        root.removeAttribute('aria-label');
        page.classList.remove('hadiyah-judgeme-loading');
        if (observer) observer.disconnect();
        document.removeEventListener('load', queueCheck, true);
      });
    });
  }

  function observeReviewRoot(root) {
    if (observedRoot === root) return;
    observedRoot = root;
    observer.disconnect();
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function check() {
    checkQueued = false;
    var root = document.querySelector(rootSelector);
    if (!root) return;
    observeReviewRoot(root);

    if (!root.hasAttribute('aria-busy')) {
      root.setAttribute('aria-busy', 'true');
      root.setAttribute('aria-label', 'Loading customer reviews');
    }

    if (findReadyWidget(root)) reveal(root);
  }

  function queueCheck() {
    if (checkQueued || revealQueued) return;
    checkQueued = true;
    window.requestAnimationFrame(check);
  }

  observer = new MutationObserver(queueCheck);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // A stylesheet load does not create a DOM mutation, so check that event too.
  document.addEventListener('load', queueCheck, true);
  queueCheck();
})();
